//components
import { useState } from 'react';
import Footer from "../components/footer.js";
import { sendLambda } from '../components/send-lambda.js';

//styling
import '../app/App.css';
import 'typeface-lato';

const Redeem = () => {
    const[redemptionCode, setRedemptionCode] = useState();

    const handleSubmit = async () => {
        if (!redemptionCode.trim()) {
            alert('Please enter a code before submitting.');
            return;
        }

        // Call Lambda validation
        const result = await sendLambda(redemptionCode);

        if (result.success) {
            alert(`Code valid! Reward granted! ${result.message}`);
        } else {
            alert('Invalid code: ' + result.message);
        }
    };


    return (
        <div className="centered">
            <h1 className="skinny-header-text"><br />Redeem a Code</h1>

            <div className="body-section">
                <h2 className="body-text" style={{ fontWeight: 700 }}>
                    Input a rewards code to earn points towards free boba!
                </h2>

                <input
                    type="text"
                    id="redemption_code"
                    name="redemption_code"
                    value={redemptionCode}
                    onChange={(e) => setRedemptionCode(e.target.value)}
                    placeholder="Enter your code"
                />

                <button type="button" onClick={handleSubmit}>
                    Submit
                </button>
            </div>

            {<Footer />}
        </div>
    )
}

export default Redeem;